import { render, staticRenderFns } from "./CustomMaterialParameter.vue?vue&type=template&id=0ece5d00&scoped=true&"
import script from "./CustomMaterialParameter.vue?vue&type=script&lang=ts&"
export * from "./CustomMaterialParameter.vue?vue&type=script&lang=ts&"
import style0 from "./CustomMaterialParameter.vue?vue&type=style&index=0&id=0ece5d00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece5d00",
  null
  
)

export default component.exports